// Settings › AI › AI: providers & routing, privacy & access, agent, usage & budgets, quality (operators).
// Old tab links keep working: Model routing is part of Providers & routing, Budgets of Usage & budgets, and
// change sets left the settings for Inbox › Change sets.
import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';
import { AiSettingsPage, aiSection } from '../../../features/ai-settings/AiSettingsPage';

export const Route = createFileRoute('/_settings/settings/ai')({
  validateSearch: z.object({ tab: z.string().max(40).optional().catch(undefined) }),
  beforeLoad: ({ search }) => {
    if (search.tab === 'changes' || search.tab === 'changesets' || search.tab === 'change-sets')
      throw redirect({ to: '/change-sets', replace: true });
  },
  component: function AiSettingsRoute() {
    return <AiSettingsPage tab={aiSection(Route.useSearch().tab)} />;
  },
});
